export default "__VITE_ASSET__BUHFpTLk__"